import React from 'react';
import { RowLoader } from '../component-loader';

const MagazineArchivePage = () => {
  return <RowLoader />;
};

export default MagazineArchivePage;
